/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_TitleInputs */

const en_svc_ai_app_rescue_title = /** @type {(inputs: Svc_Ai_App_Rescue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI App Rescue`)
};

const ar_svc_ai_app_rescue_title = /** @type {(inputs: Svc_Ai_App_Rescue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنقاذ تطبيقات الذكاء الاصطناعي`)
};

const bn_svc_ai_app_rescue_title = /** @type {(inputs: Svc_Ai_App_Rescue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এআই অ্যাপ রেসকিউ`)
};

const de_svc_ai_app_rescue_title = /** @type {(inputs: Svc_Ai_App_Rescue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-App-Rettung`)
};

const es_svc_ai_app_rescue_title = /** @type {(inputs: Svc_Ai_App_Rescue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rescate de apps con IA`)
};

const fr_svc_ai_app_rescue_title = /** @type {(inputs: Svc_Ai_App_Rescue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sauvetage d'apps IA`)
};

const pt_svc_ai_app_rescue_title = /** @type {(inputs: Svc_Ai_App_Rescue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resgate de apps com IA`)
};

const zh_svc_ai_app_rescue_title = /** @type {(inputs: Svc_Ai_App_Rescue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 应用救援`)
};

const tr_svc_ai_app_rescue_title = /** @type {(inputs: Svc_Ai_App_Rescue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YZ Uygulama Kurtarma`)
};

const ru_svc_ai_app_rescue_title = /** @type {(inputs: Svc_Ai_App_Rescue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спасение ИИ-приложений`)
};

const pl_svc_ai_app_rescue_title = /** @type {(inputs: Svc_Ai_App_Rescue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ratunek aplikacji AI`)
};

/**
* | output |
* | --- |
* | "AI App Rescue" |
*
* @param {Svc_Ai_App_Rescue_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_title = /** @type {((inputs?: Svc_Ai_App_Rescue_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_title(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_title(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_title(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_title(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_title(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_title(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_title(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_title(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_title(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_title(inputs)
	return en_svc_ai_app_rescue_title(inputs)
});
export { svc_ai_app_rescue_title as "svc_ai-app-rescue_title" }